import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppSelector } from 'src/services/redux/app/store';
import { _logOut } from 'src/services/redux/slices/auth/auth-slice';

const REACT_APP_API_URL = `${process.env.REACT_APP_API_URL}`;

export const useMarketPlaceWorkPlaceInquiryList = (onError?: any) => {
  const { user } = useAppSelector((state) => state.auth);
  const requestParams = { company_id: user?.company_id };
  const requestUrl = REACT_APP_API_URL + '/iyzipay/market-place/workplace-inquiry';
  const fetchData = async () => {
    const res = await axios.get(`${requestUrl}`, { params: requestParams });
    return res?.data || {};
  };
  return useQuery(['market-place-work-inquiry'], fetchData, {
    refetchOnWindowFocus: false,
    onError,
  });
};

// Bekleyen süre uzatma taleplerinin adedi (Topbar "Talepler" rozeti için)
export const usePendingExtensionRequestsCount = (enabled: boolean) => {
  const fetchData = async (): Promise<number> => {
    const res = await axios.get(`${REACT_APP_API_URL}/potential-customer-lifecycle/admin/extension-requests`, {
      params: { status: 'pending', limit: 1 },
    });
    return res?.data?.totalResults ?? 0;
  };
  return useQuery(['pending-extension-requests-count'], fetchData, {
    enabled,
    refetchOnWindowFocus: false,
    refetchInterval: 60000,
  });
};
